import { colorsPalettes } from "@similarweb/styles";
import classNames from "classnames";
import { Marker } from "pro-features/components/Legends/src/LegendBase/Legend";
import { WebsiteTooltip } from "app/components/React/Tooltip/WebsiteTooltip/WebsiteTooltip";
import React from "react";
import styled from "styled-components";
import { chosenSites } from "app/common/services/chosenSites";

const Wrapper = styled.span`
    min-width: 0px;
    align-items: center;
`;

const DomainWrapper = styled.span`
    margin-right: 8px;
    color: ${colorsPalettes.carbon["400"]};
`;

export class DomainCell extends React.Component<any, any> {
    render() {
        const domain = this.props.field;
        const color = chosenSites.getSiteColor(domain);
        const classes = classNames("u-flex-row value");

        return (
            <WebsiteTooltip
                domain={domain}
                hideTrackButton={true}
            >
                <Wrapper className={classes}>
                    <span>
                        <Marker color={color} />
                    </span>
                    <DomainWrapper className={"u-truncate"}> {domain} </DomainWrapper>
                </Wrapper>
            </WebsiteTooltip>
        );
    }
}

export class DomainCellWithoutTooltip extends React.Component<any, any> {
    render() {
        const domain = this.props.field;
        const color = chosenSites.getSiteColor(domain);
        const classes = classNames("u-flex-row value");

        return (
            <Wrapper className={classes}>
                <span>
                    <Marker color={color} />
                </span>
                <DomainWrapper className={"u-truncate"}> {domain} </DomainWrapper>
            </Wrapper>
        );
    }
}
